module.exports = __webpack_public_path__ + "img/manual1.40b7a48b.jpg";